import { useTab } from "lib/@components/tabs"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"
import { getSharingLink } from "routes/sharing/controller/get-sharing-link"
import { shouldShowShareLinkCommentsTab } from "routes/schedule/plugins/share-link-comments/share-link-comment-presenters"
import { ShareLinkRecipientCommentsPanel } from "./share-link-recipient-comments-panel"
import { ShareCommentsTabLabel } from "./share-comments-tab-label"
import { useShareLinkCommentRegimeId } from "./use-share-link-comment-regime-id"

export const SHARE_COMMENTS_TAB_ID = "share-comments"

// Adds a recipient Comments tab to the regime tab bar (alongside Schedules / Overview) when the share
// link allows comments. Uses useTab (not module-level registerTab) so the allowComments check — which
// needs the fetched share link — can gate the tab. The tab aggregates the recipient's schedule / task /
// introduction comment threads (read + reply); new comments are created inline on the schedule items.
export function ShareCommentsTabRegistrar() {
    const [shareLinkId] = useSearchParam("share", null)
    const shareLink = getSharingLink.useResults(shareLinkId)
    const regimeId = useShareLinkCommentRegimeId()
    const canShow = shouldShowShareLinkCommentsTab({ shareLinkId, shareLink })

    useTab({
        tab: REGIME_ASSETS_TAB,
        id: SHARE_COMMENTS_TAB_ID,
        title: canShow ? <ShareCommentsTabLabel shareLinkId={shareLinkId} regimeId={regimeId} /> : false,
        content: canShow ? <ShareLinkRecipientCommentsPanel priority={150} /> : null,
    })

    return null
}
